// This code observes the body for changes and applies styles to the newsletter form
const observer = new MutationObserver((mutationsList, observer) => {
  const newsletter = document.querySelector('[id^="app-embed-container-"]')?.shadowRoot;
  if (newsletter) {
    const style = document.createElement('style');
    style.textContent = `
        /* Your CSS styles here */
        section[data-testid="banner-success"] {
            h2 {
                font-family: var(--font-heading-family) !important;
                font-weight: 500 !important;
                font-size: 28px !important;
                @media and screen and (min-width: 990px) {
                    font-size: 36px !important;
                }
            }
        }
        section[data-testid="form-container"]{
            --container-max-w: 450px !important;
            box-shadow: none !important;
            border-radius: 0px !important;
            p, input, button, label, output {
                font-family: var(--font-body-family) !important;
            }
            button {
                text-transform: uppercase !important;
                letter-spacing: 3.52px !important;
                font-weight: 700 !important;
            }
            input, button {
                border-radius: 0px !important;
            }
            input:focus-visible {
                --form-field-border-focused: 0 0 0 1px rgba(16, 16, 16, 0.6) !important;
            }
            h2 {
                font-family: var(--font-heading-family) !important;
                font-weight: 500 !important;
                font-size: 28px !important;
                @media and screen and (min-width: 990px) {
                    font-size: 36px !important;
                }
            }
            p {
                margin: 15px 0 !important;
                > a {
                    color: inherit !important;
                    font-weight: 700 !important;
                }
            }
            *[class^="_textBody_"] > p {
                font-size: 16px !important;
                @media and screen and (min-width: 990px) {
                    font-size: 18px !important;
                }
            }
            *[class^="_formDisclaimer_"] > p {
                font-size: 12px !important;
            }
        }
    `;
    newsletter.prepend(style);
    observer.disconnect(); // Stop observing once the form is styled
  }
});

observer.observe(document.body, { childList: true });
